import React from 'react';

/* 资源图标，hot or free */
export const LABEL_MAP = {
  hot: (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_849_104187)">
        <rect width="100" height="22" transform="translate(11 -21) rotate(45)" fill="url(#paint0_linear_849_104187)" />
        <path
          d="M31.1653 21.7928L38.0949 14.8632L39.4512 16.2194L32.5215 23.1491L31.1653 21.7928ZM26.6016 17.2292L33.5412 10.2896L34.8974 11.6458L27.9578 18.5854L26.6016 17.2292ZM30.5317 15.3186L31.7791 14.0712L35.9764 18.2686L34.7291 19.5159L30.5317 15.3186ZM36.3993 27.2644C35.8977 26.7628 35.5578 26.2052 35.3796 25.5914C35.2146 24.9776 35.2146 24.3639 35.3796 23.7501C35.5512 23.1429 35.8911 22.5853 36.3993 22.0771C36.9075 21.5689 37.4651 21.229 38.0723 21.0574C38.6795 20.8858 39.2866 20.8858 39.8938 21.0574C40.5076 21.2224 41.0653 21.5557 41.5668 22.0573C42.075 22.5655 42.4116 23.1264 42.5766 23.7402C42.7482 24.3474 42.7482 24.9545 42.5766 25.5617C42.405 26.1689 42.0651 26.7265 41.5569 27.2347C41.0488 27.7429 40.4911 28.0828 39.8839 28.2544C39.2767 28.426 38.6663 28.4293 38.0525 28.2643C37.4519 28.0993 36.9009 27.766 36.3993 27.2644ZM37.607 26.0567C37.8512 26.3009 38.1251 26.456 38.4287 26.522C38.7323 26.5879 39.0359 26.5682 39.3394 26.4626C39.6562 26.357 39.9499 26.1689 40.2205 25.8983C40.4911 25.6277 40.6759 25.3373 40.7749 25.0271C40.8805 24.7103 40.897 24.3969 40.8244 24.0867C40.7584 23.7831 40.6033 23.5092 40.3591 23.265C40.1215 23.0274 39.8476 22.8723 39.5374 22.7997C39.2338 22.7337 38.9237 22.7535 38.6069 22.8591C38.2967 22.9581 38.0063 23.1429 37.7357 23.4135C37.4651 23.6841 37.277 23.9778 37.1714 24.2946C37.0725 24.6048 37.0593 24.9149 37.1319 25.2251C37.2044 25.5353 37.3628 25.8125 37.607 26.0567ZM42.2179 33.083C41.6701 32.5353 41.3896 31.9842 41.3764 31.4298C41.3698 30.882 41.6173 30.3574 42.1189 29.8558L47.1677 24.8071L48.4744 26.1138L43.7127 30.8754C43.5015 31.0866 43.386 31.2945 43.3662 31.4991C43.353 31.6971 43.4355 31.8852 43.6137 32.0634C43.6797 32.1294 43.7655 32.1888 43.8711 32.2416C43.9833 32.2878 44.112 32.3241 44.2572 32.3505L43.7325 33.7859C43.4553 33.7463 43.1815 33.6638 42.9109 33.5384C42.6403 33.4262 42.4093 33.2744 42.2179 33.083ZM43.7127 26.6583L44.8215 25.5495L48.1675 28.8955L47.0588 30.0043L43.7127 26.6583Z"
          fill="#FFF5F5"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_849_104187"
          x1="0"
          y1="0"
          x2="68.058"
          y2="58.9052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5353" />
          <stop offset="1" stop-color="#FF7A00" />
        </linearGradient>
        <clipPath id="clip0_849_104187">
          <rect width="100" height="22" fill="white" transform="translate(11 -21) rotate(45)" />
        </clipPath>
      </defs>
    </svg>
  ),
  free: (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_849_104189)">
        <rect width="100" height="22" transform="translate(11 -21) rotate(45)" fill="url(#paint0_linear_849_104189)" />
        <path
          d="M23.1735 15.2151L31.0931 7.29553L36.173 12.3754L34.7587 13.7896L31.2289 10.2597L29.3282 12.1604L32.2697 15.102L30.8555 16.5162L27.9139 13.5746L24.7235 16.7651L23.1735 15.2151ZM33.4938 19.5844C34.1048 18.9735 34.727 18.5851 35.3606 18.4191C36.0017 18.2607 36.6051 18.2683 37.1708 18.4417C37.744 18.6228 38.2343 18.9169 38.6415 19.3242L37.1934 20.7724C36.8464 20.4254 36.4769 20.1388 36.0847 19.9125C35.7 19.6938 35.3191 19.5844 34.942 19.5844C34.5648 19.5844 34.2292 19.7315 33.935 20.0257L33.4938 19.5844ZM29.4661 21.5078L35.123 15.8509L36.6164 17.3443L30.9595 23.0012L29.4661 21.5078ZM36.5277 28.8408C35.9695 28.2827 35.5999 27.6642 35.4189 26.9854C35.2454 26.299 35.2567 25.6089 35.4529 24.915C35.6565 24.2286 36.0487 23.595 36.6295 23.0143C37.2102 22.4335 37.8476 22.045 38.5415 21.8489C39.2429 21.6604 39.9369 21.6604 40.6232 21.8489C41.3247 22.0375 41.962 22.4184 42.5352 22.9916C43.033 23.4894 43.3574 24.0777 43.5082 24.7566C43.6741 25.4354 43.6289 26.1519 43.3724 26.9062C43.1311 27.6604 42.6521 28.3958 41.9356 29.1123L37.6477 24.8244H37.9192C37.6402 25.1035 37.4629 25.4165 37.3875 25.7635C37.3272 26.1104 37.3498 26.4498 37.4554 26.7817C37.5761 27.1136 37.7646 27.4077 38.0211 27.6642C38.3303 27.9734 38.6471 28.162 38.9714 28.2299C39.3033 28.2902 39.6276 28.2676 39.9444 28.162L40.759 30.0174C40.2838 30.1758 39.8011 30.2437 39.3108 30.2211C38.8356 30.1985 38.3642 30.074 37.8966 29.8477C37.429 29.6215 36.9727 29.2858 36.5277 28.8408ZM38.8356 24.0664L38.8356 23.7949L41.5623 26.5215L41.302 26.5328C41.5736 26.2613 41.7244 25.9822 41.7546 25.6956C41.7923 25.4014 41.7546 25.1224 41.6414 24.8584C41.5359 24.6019 41.3963 24.387 41.2228 24.2135C41.0494 24.04 40.8269 23.893 40.5553 23.7723C40.2838 23.6516 39.9934 23.6026 39.6842 23.6252C39.39 23.6478 39.1072 23.7949 38.8356 24.0664ZM43.1457 35.4589C42.5876 34.9007 42.218 34.2823 42.037 33.6034C41.8635 32.9171 41.8748 32.2269 42.0709 31.533C42.2746 30.8467 42.6668 30.2131 43.2476 29.6323C43.8283 29.0516 44.4657 28.6631 45.1596 28.467C45.861 28.2785 46.5549 28.2785 47.2413 28.467C47.9427 28.6556 48.5801 29.0365 49.1533 29.6097C49.6511 30.1075 49.9754 30.6958 50.1263 31.3746C50.2922 32.0535 50.247 32.77 49.9905 33.5242C49.7492 34.2785 49.2702 35.0139 48.5537 35.7304L44.2658 31.4425H44.5373C44.2582 31.7216 44.081 32.0346 44.0056 32.3816C43.9452 32.7285 43.9679 33.0679 44.0735 33.3998C44.1941 33.7317 44.3827 34.0258 44.6391 34.2823C44.9484 34.5915 45.2652 34.7801 45.5895 34.8479C45.9214 34.9083 46.2457 34.8857 46.5625 34.7801L47.3771 36.6355C46.9019 36.7939 46.4192 36.8618 45.9289 36.8392C45.4537 36.8165 44.9823 36.6921 44.5147 36.4658C44.0471 36.2395 43.5907 35.9039 43.1457 35.4589ZM45.4537 30.6845L45.4537 30.413L48.1803 33.1396L47.9201 33.1509C48.1916 32.8794 48.3425 32.6003 48.3727 32.3137C48.4104 32.0195 48.3727 31.7405 48.2595 31.4765C48.1539 31.22 48.0144 31.0051 47.8409 30.8316C47.6674 30.6581 47.4449 30.511 47.1734 30.3903C46.9019 30.2697 46.6115 30.2206 46.3023 30.2433C46.0081 30.2659 45.7253 30.413 45.4537 30.6845Z"
          fill="#FFF5F5"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_849_104189"
          x1="-2.5641"
          y1="11"
          x2="100"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00BB5A" />
          <stop offset="1" stop-color="#51DE95" />
        </linearGradient>
        <clipPath id="clip0_849_104189">
          <rect width="100" height="22" fill="white" transform="translate(11 -21) rotate(45)" />
        </clipPath>
      </defs>
    </svg>
  ),
};

/* 资源类型 */
export const VIDEO = 'video';
export const AUDIO = 'audio';
export const DOCUMENT = 'document';

/* 资源科目值映射 */
export const SUBJECT_VALUE_MAP = {
  中文: 'chinese',
  数学: 'math',
  英文: 'english',
  chinese: '中文',
  math: '数学',
  english: '英文',
};

/* 资源默认封面映射 */
export const DEFAULT_COVER_MAP = {
  [VIDEO]: '/images/resources/resource_item_placeholder_video.svg',
  [AUDIO]: '/images/resources/resource_item_placeholder_audio.svg',
  [DOCUMENT]: '/images/resources/resource_item_placeholder_doc.svg',
};

/* 资源浏览记录映射 */
export const POST_VIEW_RECORD_MAP = {
  [VIDEO]: 'PLAY',
  [AUDIO]: 'PLAY',
  [DOCUMENT]: 'DOWN',
};

/* 面包屑科目类型映射 */
export const BREAD_SUBJECT_MAP = {
  中文: 'chinese',
  数学: 'math',
  英文: 'english',
  Chinese: 'chinese',
  Math: 'math',
  English: 'english',
};

/* 详情页标签类型映射 */
export const DETAIL_TAG_MAP = {
  中文: '国际中文',
  数学: '国际数学',
  英文: '英文读写',
  Chinese: 'Chinese',
  Math: 'Math',
  English: 'English Language Arts',
};
